import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Explain from '../views/explain.vue'
import TeacherList from '../views/teacherList.vue'
import Appointment from '../views/appointment.vue'
import SchoolList from '../views/SchoolList.vue'
import examList from '../views/examList.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  { 
    path:'/explain',
    name:'explain',
    component:Explain
  },
  { 
    path:'/teacherList',
    name:'teacherList',
    component:TeacherList
  }
  ,
  { 
    path:'/appointment',
    name:'appointment',
    component:Appointment
  },
  { 
    path:'/schoollist',
    name:'schoollist',
    component:SchoolList
  },
  { 
    path:'/expertlist',
    name:'expertlist',
    component:examList
  },
]

const router = new VueRouter({
  mode: 'history',
  //base:'/special/uk_expo_master_2020_m',
  base: process.env.BASE_URL,
  routes
})

export default router
